import { StatCard } from './StatCard'
import { DashboardModel } from '@/types'
import { useBusiness } from '@/contexts/BusinessContext'

interface DashboardStatsProps {
  stats: DashboardModel.Stat[]
  /** Revenue series, shown as the revenue card's sparkline. */
  revenueSpark?: number[]
}

const isRevenue = (title: string) => /revenue|sales/i.test(title)

/** The KPI row, one metric card per stat (Shopify Analytics' top row). */
export const DashboardStats = ({ stats, revenueSpark }: DashboardStatsProps) => {
  const { formatCurrency } = useBusiness()
  const format = (title: string, value: number | string) => {
    const n = Number(value)
    if (value === '' || !Number.isFinite(n)) return value
    return isRevenue(title) ? formatCurrency(n) : n.toLocaleString()
  }

  return (
    <div className="grid grid-cols-2 gap-3 xl:grid-cols-4">
      {stats?.map((stat) => (
        <StatCard
          key={stat.title}
          title={stat.title}
          value={format(stat.title, stat.value)}
          change={stat.change}
          trend={stat.trend}
          spark={isRevenue(stat.title) ? revenueSpark : undefined}
          note={stat.note}
        />
      ))}
    </div>
  )
}
